import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress'

export default class LoadingSplash extends Component {
  render() {
    return (
      <div style={{
        background: '#f57c00',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        top: '0',
        left: '0'
      }}>
        <CircularProgress
          color='#fff'
          size={150}
          thickness={8}
        />
        <h2 style={{
          color: '#fff',
          fontWeight: '400'
        }}>Loading</h2>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingSplash.js